﻿import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { Event, NavigationStart, NavigationEnd, RouteConfigLoadStart, ResolveStart, NavigationError, RoutesRecognized, NavigationCancel } from '@angular/router';
@Injectable()
export class AuthGuard implements CanActivate {
  currentUserSubject = [];
  constructor(private router: Router, private cs: ApiService, private activatedRoute: ActivatedRoute) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (localStorage.getItem('token')) {
      return true;
    }
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

}